import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function GeographicDistribution({ chart_data, setRegionId, setRegionName }) {
  const [label, setLabel] = useState([]);
  const [values, setValues] = useState([]);
  const [netAddValues, setNetAddValues] = useState([]);
  const [data, setData] = useState({});
  const [options, setOptions] = useState({});
  const [regionMapping, setRegionMapping] = useState({});

    let userLoging = {};
    let currencies = [];
    userLoging = JSON.parse(localStorage.getItem("user") || "{}");
    currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
    const defaultCurrencyId = Number(userLoging?.default_currency_id || 1);
    const selectedCurrency = currencies.find(
    (currency) =>
      Number(currency.value) === defaultCurrencyId
  );
    const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
    const currencyType = defaultCurrencyId === 1 ? "en-IN" : "en-US";
    const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "K";
    const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000;

  useEffect(() => {
    let regions = [];
    let revenue = [];
    let net_add = [];
    let mapping = {};
    let europeTotal = 0;
    let europeNetAdd = 0;
    chart_data?.forEach((item) => {
      if (item.id === 1) {
        regions.push("MEA");
        revenue.push(item.total_amount);
        net_add.push(item.net_add);
        mapping["MEA"] = [1];
      } else if (item.id === 4 || item.id === 10) {
        europeTotal += item.total_amount; // accumulate
        europeNetAdd += item.net_add;
      } else if (item.id === 6) {
        regions.push("Americas");
        revenue.push(item.total_amount);
        net_add.push(item.net_add);
        mapping["Americas"] = [6];
      } else if (item.id === 8) {
        regions.push("SEA");
        revenue.push(item.total_amount);
        net_add.push(item.net_add);
        mapping["SEA"] = [8];
      } else {
        regions.push(item.region_name);
        revenue.push(item.total_amount);
        net_add.push(item.net_add);
        mapping[item.region_name] = [item.id];
      }
    });

    // Add Europe only once
    if (europeTotal > 0) {
      regions.push("Europe");
      revenue.push(europeTotal);
      net_add.push(europeNetAdd);
      mapping["Europe"] = [4, 10];
    }

    revenue = revenue?.map((item) => item / amountDivisor); // convert to Cr
    net_add = net_add?.map((item) => item / amountDivisor);

    setLabel(regions);
    setValues(revenue);
    setNetAddValues(net_add);
    setRegionMapping(mapping);
  }, [chart_data]);

  useEffect(() => {
    if (label.length === 0) return;

    setData({
      labels: label,
      datasets: [
        {
          label: "Revenue",
          data: values,
          backgroundColor: "#36A2EB",
          borderRadius: 12,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          // ❌ ensures no value printed on bar
          datalabels: { display: false },
        },
        {
          label: "Net Add",
          data: netAddValues,
          backgroundColor: "#FF6384",
          borderRadius: 12,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          datalabels: { display: false },
        },
      ],
    });

    setOptions({
      indexAxis: "x", // vertical bars (X-axis regions)
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: true, position: "top" },
        datalabels: { display: false }, // ⛔ hides bar labels
        tooltip: {
          callbacks: {
            label: (context) =>
              `${context.dataset.label}: ${symbol} ${context.raw.toFixed(2)} ${amountSuffix}`,
          },
        },
      },
      scales: {
        x: { title: { display: true, text: "Geographic Region" } },
        y: {
          ticks: {
            callback: (value) => `${symbol} ${value} ${amountSuffix}`,
          },
          title: { display: true, text: "Revenue" },
        },
      },
      onClick: (evt, elements) => {
        if (!elements.length) return;

        const index = elements[0].index; // clicked bar index
        const regionName = label[index];
        const regionIds = regionMapping[regionName] || [];

        // Assign to parent via props
        setRegionId(regionIds); // array of ids
        setRegionName(regionName); // string

        console.log("Clicked region:", regionName, "IDs:", regionIds);
      },
      onHover: (event, elements) => {
        if (elements.length > 0) {
          event.native.target.style.cursor = "pointer";
        } else {
          event.native.target.style.cursor = "default";
        }
      },
    });
  }, [label, values, regionMapping, setRegionId, setRegionName]);

  return (
    <div style={{ width: "100%", height: "350px", margin: "auto" }}>
      {data?.datasets ? <Bar data={data} options={options} /> : null}
    </div>
  );
}

export default GeographicDistribution;
